<template>
  <div class="million-read-book"
       :class="[
         `type-${type}`,
       ]"
  >
    <ym-img class="million-read-book-cover"
            :src="cover"
    />
    <book-tag v-if="!hideBookTag"
              class="million-read-book-tag"
              :book-type="bookType"
    />
    <div v-if="progress !== ''"
         class="million-read-book-progress"
    >
      {{ progress }}
    </div>
  </div>
</template>

<script>
  import BookTag from '@/pages/MillionRead/components/BookTag';

  export default {
    name: 'MillionReadBookCover',
    components: {
      BookTag,
    },
    props: {
      cover: {
        type: String,
        required: true,
      },
      bookType: {
        type: String,
      },
      progress: {
        type: String,
        default: '',
      },
      hideBookTag: {
        type: Boolean,
        default: true,
      },
      type: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'extra-small',
            'small',
            'normal',
          ].includes(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book {
    flex-shrink: 0;
    position: relative;
    &.type-normal {
      width: 210px;
      height: 280px;
    }
    &.type-small {
      width: 190px;
      height: 252px;
    }
    &.type-extra-small {
      width: 160px;
      height: 210px;
    }

    &-cover {
      /deep/ img {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 1px solid #f5f6f7;
        border-radius: 8px;
      }
    }
    &-tag {
      position: absolute;
      top: 8px;
      left: 8px;
    }
    &-progress {
      box-sizing: border-box;
      position: absolute;
      top: 0;
      right: 16px;
      width: 52px;
      height: 36px;
      display: flex;
      align-content: center;
      justify-content: center;
      color: @color-white;
      font-size: 14px;
      line-height: 36px;
      background: url('~@/assets/img/million_read/book_progress_icon.png') no-repeat;
      background-size: 52px 36px;
    }
  }

</style>
